const trackEvent = (data = {}) => {
  try {
    if (data.object && data.action) {
      return analytics.track({
        event: `${data.object} ${data.action}`,
        hotelId: data.hotelId,
        userId: data.userId,
        properties: data.details,
      });
    }
  } catch (error) {
    console.log('Error in Track Event:::::', JSON.stringify(error, null, 2));
  }
};

const identifyUser = (data = {}) => {
  try {
    return analytics.identify(data.userId, {
      name: data.name,
      email: data.email,
      phoneNumber: data.phoneNumber,
      propertyId: data.propertyId,
      property: data.property,
    });
  } catch (error) {
    console.log('Error in Identify Event:::::', JSON.stringify(error, null, 2));
  }
}

const ANALYTICS_OBJECTS = {
  TASK: 'Task',
  FIRST_TASK: 'First Task',
  TASK_WITH_CHECKLIST: 'Task with Checklist',
  TASK_START_DUE_TIME: 'Task - Start/Due time',
  RECURRING_TASK: 'Recurring Task',
  ROOM: 'Room',
  ROOM_OPTIONAL_NAME: 'Room - Optional Name',
  ROOM_OPTIONAL_BED_DETAIL: 'Room - Optional Bed Detail',
  ROOM_OPTIONAL_BATH_DETAIL: 'Room - Optional Bath Detail',
  FLOOR: 'Floor',
  AREA: 'Area',
  LOCATION: 'Location',
  ASSET: 'Asset',
  DOCUMENT: 'Document',
  SOP: 'SOP',
  CHANNEL: 'Message - Channel',
  GROUP: 'Message - Group',
  PUBLIC_FEED: 'Message - Public Feed',
  CHANNEL_MESSAGE: 'Message - Channel Message',
  DIRECT_MESSAGE: 'Message - Direct Message',
  GROUP_MESSAGE: 'Message - Group Message',
  CHECKLIST: 'Checklist',
  CHECKLIST_IN_TASK: 'Checklist in Task',
  CHECKLIST_LOG: 'Checklist Log',
  VIEW_CHECKLIST_REPORT: 'View Checklist Report',
  FIRST_CHECKLIST: 'First Checklist',
  CHECKLIST_ITEMS: 'Checklist Items',
  FIRST_CHECKLIST_ITEM: 'First Checklist Item',
  CHECKLIST_FOLDER: 'Checklist Folder',
  FIRST_CHECKLIST_FOLDER: 'First Checklist Folder',
  USER: 'User',
  SESSION: 'Session',
  HOTEL: 'Hotel',
  SIGNUP: 'Signup',
  TEAM: 'Team',
  PUBLIC_TEMPLATE: 'Public Template',
  BILLING_TAB_IN_SETTINGS: 'Billing Tab in Settings',
  VIEW_PRICING_PLANS: 'View Pricing Plans',
  UPGRADE_NOW_YELLOW_BUTTON: 'Upgrade Now Yellow Button',
};

const ANALYTICS_ACTIONS = {
  FORGOT_PASSWORD: 'Forgot Password',
  STARTED: 'Started',
  PAUSED: 'Paused',
  USED: 'Used',
  COMPLETED: 'Completed',
  COMPLETED_FROM_MOBILE: 'Completed - mobile',
  COMPLETED_FROM_WEB: 'Completed - web',
  SUBMITTED_FROM_MOBILE: 'Submitted - mobile',
  SUBMITTED_FROM_WEB: 'Submitted - web',
  RE_ASSIGNED: 'Re-Assigned',
  UNASSIGNED: 'Unassigned',
  RE_ASSIGNED_WEB: 'Re-Assigned - mobile',
  RE_ASSIGNED_MOBILE: 'Re-Assigned - web',
  CREATED: 'Created',
  UPLOADED: 'Uploaded',
  ASSIGNED_WEB: 'Assigned - web',
  ASSIGNED_MOBILE: 'Assigned - mobile',
  CREATED_FROM_WEB: 'Created - web',
  CREATED_FROM_MOBILE: 'Created - mobile',
  CREATED_UNASSIGNED: 'Created Unassigned',
  DELETED: 'Deleted',
  ADDED: 'Added',
  SENT: 'Sent',
  VIEWED: 'Viewed',
  READ: 'Read',
  MEMBER_REMOVED: 'Member Removed',
  EDITED: 'Edited',
  IN_PROGRESS: 'In Progress',
  MARKED_INACTIVE: 'Marked Inactive',
  BECOMES_ADMIN: 'Becomes Admin',
  ADMIN_PRIVILEGE_REMOVED: 'Admin Privilege Removed',
  COMMENT_ADDED: 'Comment Added',
  NEW_MEMBER_ADDED: 'New Member Added',
  FLAGGED: 'Flagged',
  LOGIN: 'Login',
  LOGIN_FROM_WEB: 'Login - web',
  LOGIN_FROM_MOBILE: 'Login - mobile',
  FIRST_LOGIN: 'First Login',
  CLICKED: 'Clicked',
  INVITED_VIA_EMAIL: 'Invited via Email',
  INVITED_VIA_PHONE: 'Invited via Phone',
  INVITED_FROM_ONBOARDING_FLOW: 'Invited from Onboarding Flow',
};

module.exports = {
  trackEvent,
  identifyUser,
  ANALYTICS_OBJECTS,
  ANALYTICS_ACTIONS,
};
